exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".salesforce .col-xs-12.spark-checkbox {\n  padding: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap!./src/components/pages/manage/apps/SalesforceSection.scss
// module id = 1370
// module chunks = 0